try{self['workbox:sw:6.1.5']&&_()}catch(e){}// eslint-disable-line